// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__lc8BL","boxTitle":"Qualiphy_boxTitle__299nU","box":"Qualiphy_box__2J6no","toggleWrap":"Qualiphy_toggleWrap__1LZNC"};